// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"19":"DemandChecker","822":"PriceCheckDetailed","830":"PriceHistory"}[chunkId] + "." + {"19":"25f9df8a","822":"6d9569ee","830":"8abb6a10"}[chunkId] + ".chunk.js";
};